module.exports = __webpack_public_path__ + "img/hr-tree-02-c-trunk.d35558ac.png";